export default __webpack_public_path__ + "static/tour-example5-99c3e077a39905b274e60884ad9ffc1b.png";